import type { ChakraProps } from '@/ui';

export const layerStyles: Record<string, ChakraProps> = {
  ahPanel: {
    bg: 'surface.panel',
    borderColor: 'line.panel',
  },
  ahCard: {
    bg: 'surface.card',
    borderWidth: '1px',
    borderColor: 'line.card',
    borderRadius: 'ah-xl',
    boxShadow: '0 1px 2px rgba(60,50,110,0.05)',
  },
  ahIconChip: {
    bg: 'magicPurple.25',
    color: 'magicPurple.500',
    borderRadius: 'ah-md',
  },
  ahTabRail: {
    bg: 'rgba(255,255,255,0.75)',
    borderWidth: '1px',
    borderColor: 'line.panel',
    borderRadius: '11px',
    boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.045)',
  },
  // Diagonal pink/gray hatch marking a hidden item (e.g. a hidden source event),
  // matching the Schedule sources view. Replaces the item's background fill.
  ahHidden: {
    backgroundImage:
      'linear-gradient(135deg, #eea7ca 4.55%, #e8e8e8 4.55%, #e8e8e8 50%, #eea7ca 50%, #eea7ca 54.55%, #e8e8e8 54.55%, #e8e8e8 100%)',
    backgroundSize: '15.56px 15.56px',
  },
  magicBackground: {
    bgImage: 'linear-gradient(#dcd3ef, rgba(245, 225, 239, 0.5))',
    bgAttachment: 'fixed',
  },
  magicBackgroundSecondary: {
    bgImage: 'linear-gradient(180deg, #D1D6F4 0%, #F9EAF3 100%)',
    bgAttachment: 'fixed',
  },
  magicBackgroundTertiary: {
    bgImage: 'linear-gradient(267deg, #D2E4FF 8.07%, #FFE0F5 94.94%)',
    bgAttachment: 'fixed',
  },
  magicPageBackground: {
    bgImage: 'linear-gradient(180deg, #d2e2fb 0%,#f3f8ff 95%)',
    bgAttachment: 'fixed',
  },
  magicPageTealBackground: {
    bgImage: 'linear-gradient(182.14deg, #DDF0F0 1.79%, #F6FFFF 98.2%)',
    bgAttachment: 'fixed',
  },
  // The same yellow as the planner tile.
  magicPlannerBackground: {
    bgImage: 'linear-gradient(180deg, #FBEBC6 0%, #FFFBF0 100%)',
    bgAttachment: 'fixed',
  },
  // The same pink as the school tile on the dashboard.
  magicSchoolsBackground: {
    bgImage: 'linear-gradient(180deg, #f6d9ec 0%,#fff5fb 95%)',
    bgAttachment: 'fixed',
  },
};
